import authService from '../api-authorization/AuthorizeService'
//import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';

export default class ReporteDespachoBananoService {
    async ReporteDespacho(year, week, destinos) {
        const token = await authService.getAccessToken();
        var queryString = '?year=' + year + '&week=' + week + '&destinos=' + destinos;
        const reporteResponse = await fetch('api/ReporteDespacho/ExcelDataBanano' + queryString, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const rows = await reporteResponse.json();
        rows.forEach(row => {
            // Iterate through each key (column) in the row object
            for (let key in row) {
                if (row.hasOwnProperty(key)) {
                    // If the value is 0, replace it with an empty string
                    if (row[key] === 0) {
                        row[key] = "";
                    }
                }
            }
        });

        var semanaResponse = await fetch('api/semanas?year=' + year + '&week=' + week, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const semanas = await semanaResponse.json();
        const semana = semanas.find(x => x.year == year && x.week == week);
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows, { origin: "A3", skipHeader: true });
        /*        worksheet['!autofilter'] = { ref: "A1:D4" };*/
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const columns = [
            "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
            "AA", "AB", "AC", "AD", "AE"
        ]
        //const columns = [
        //    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
        //    "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV"
        //]

        var style_h1 = {
            fill: { fgColor: { rgb: "262626" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                color: { rgb: "FFFFFF" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h2 = {
            fill: { fgColor: { rgb: "D8E4BC" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h3 = {
            fill: { fgColor: { rgb: "FCD5B4" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h4 = {
            fill: { fgColor: { rgb: "B8CCE4" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h5 = {
            fill: { fgColor: { rgb: "E6B8B7" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h6 = {
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: true,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_default = {
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }

        /* fix headers */
        XLSX.utils.sheet_add_aoa(worksheet, [["", "", "", "",
            "Primera", "", "", "", "", "", "Segunda", "", "", "", "", "", "Tercera", "", "", "", "", "", "Mixto (80/20)", "", "", "", "", ""
        ]], { origin: "A1" });
        //worksheet["!merges"] = [
        //    { s: { r: 0, c: 4 }, e: { r: 0, c: 7 } }, { s: { r: 0, c: 8 }, e: { r: 0, c: 12 } }, { s: { r: 0, c: 13 }, e: { r: 0, c: 16 } },
        //    { s: { r: 0, c: 17 }, e: { r: 0, c: 20 } }, { s: { r: 0, c: 21 }, e: { r: 0, c: 24 } }, { s: { r: 0, c: 25 }, e: { r: 0, c: 28 } },
        //    { s: { r: 0, c: 29 }, e: { r: 0, c: 31 } }, { s: { r: 0, c: 32 }, e: { r: 0, c: 34 } }, { s: { r: 0, c: 35 }, e: { r: 0, c: 37 } },
        //    { s: { r: 0, c: 38 }, e: { r: 0, c: 40 } }, { s: { r: 0, c: 41 }, e: { r: 0, c: 43 } }, { s: { r: 0, c: 44 }, e: { r: 0, c: 45 } },
        //];

        const adjustedMerges = [
            { s: { r: 0, c: 4 }, e: { r: 0, c: 9} },       // "Primera" 6 columns
            { s: { r: 0, c: 10 }, e: { r: 0, c: 15 } },      // "Segunda" 6 columns
            { s: { r: 0, c: 16 }, e: { r: 0, c: 21 } },     // "Tercera" 6 columns
            { s: { r: 0, c: 22 }, e: { r: 0, c: 27 } },     // "Mixto (80/20)" 6 columns
            // Add more entries if needed based on your actual data
        ];

        worksheet["!merges"] = adjustedMerges;

        worksheet["I1"].s = style_h2;
        XLSX.utils.sheet_add_aoa(worksheet, [["Fornitore", "Puerto de descarga", "Numero Contenedor ", "Marca",
            "18", "45", "48", "50", "54", "100", "18", "45", "48", "50", "54", "100", "18", "45", "48", "50", "54", "100", "18", "45", "48", "50", "54", "100",
            "TOT", "BL", "Sigilo"
        ]], { origin: "A2" });

        var lastIndex = rows.length + 2;
        for (var r = 3; r <= lastIndex; r++) {
            worksheet["AC" + r] = { t: "n", v: 0, f: "=SUMIF(E" + r + ":AB" + r + ",\"<>\",E" + r + ":AB" + r + ")" };
            for (var c = 4; c < (columns.length - 3); c++) {
                var cell = columns[c] + (r);
                console.log(cell);
                worksheet[cell].z = "0;-0;;@";
                //worksheet[cell].f = "0;-0;;@";
                //worksheet[cell].w = "0;-0;;@";
            }
        }

        var formulas = [];
        for (var c = 4; c < (columns.length - 2); c++) {
            formulas.push({ t: "n", v: 0, f: "=SUMIF(" + columns[c] + "3:" + columns[c] + lastIndex + ",\"<>\" ," + columns[c] + "3:" + columns[c] + lastIndex + ")" });
        }
        XLSX.utils.sheet_add_aoa(worksheet, [formulas], { origin: "E" + (rows.length + 3) });

        worksheet['!autofilter'] = { ref: "A2:AE2" };

        var wsrows = [];
        for (let i = 0; i < lastIndex; i++) {
            if (i == 0) {
                wsrows.push({ hpx: 15.75 })
            }
            else if (i == 1) {
                wsrows.push({ hpx: 36.75 })
            }
            else {
                wsrows.push({ hpx: 17.5 })
            }

        }
        worksheet['!rows'] = wsrows; // ws - worksheet

        var wscols = [];
        for (let i = 0; i < columns.length; i++) {
            if (i == 0) {
                wscols.push({ wch: 28 })
            }
            else if (i == 1) {
                wscols.push({ wch: 20 })
            }
            else if (i == 2) {
                wscols.push({ wch: 20 })
            }
            else if (i == 3) {
                wscols.push({ wch: 32 })
            }
            else if (i < 28) {
                wscols.push({ wch: 5 })
            }
            else if (i == 28) {
                wscols.push({ wch: 10 })
            }
            else if (i < 31) {
                wscols.push({ wch: 20 })
            }
            else {
                wscols.push({ wch: 8.43 })
            }

        }
        worksheet['!cols'] = wscols; // ws - worksheet

        for (var r = 0; r < (rows.length + 3); r++) {
            for (var c = 0; c < (columns.length); c++) {
                var cell = columns[c] + (r + 1);
                if (worksheet[cell] == null) {
                    continue;
                }
                if (c == 0) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }

                }
                else if (c == 1) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 2) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 3) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c < 10) {
                    if (r < 2) {
                        worksheet[cell].s = style_h2;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c < 16) {
                    if (r < 2) {
                        worksheet[cell].s = style_h3;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c < 22) {
                    if (r < 2) {
                        worksheet[cell].s = style_h4;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c < 28) {
                    if (r < 2) {
                        worksheet[cell].s = style_h5;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 28) {
                    if (r == 1) {
                        worksheet[cell].s = style_h1;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 29) {
                    if (r == 1) {
                        worksheet[cell].s = style_h1;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 30) {
                    if (r == 1) {
                        worksheet[cell].s = style_h1;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else {
                    worksheet[cell].s = style_default;

                }

            }
        }

        /* create an XLSX file and try to save to Presidents.xlsx */
        XLSX.writeFile(workbook, "ReporteDespacho_" + semana.nombre + ".xlsx", { compression: true });
    }
}